// extracted by mini-css-extract-plugin
module.exports = {"text":"SectionText_text__2yZiX"};